export const ACCOUNT_TITLE = 'Account Error';
export const ACCOUNT_BODY =
  "It appears you don't have a valid Spotify Premium subscription. You must have one in order to use ToneBirds.";
export const ALREADY_A_MEMBER = 'Already signed up for premium?';
export const AUTH_TITLE = 'Authentication Error';
export const INITIALIZATION_TITLE = 'Player Error';

const STANDARD_TEXT =
  'Please refresh to try again. If this problem continues please reach out to us using the "Feedback" tab to your right';
export const GEN_AUTH_BODY_TEXT = `Failed to authorize your Spotify user. Please connect your Spotify account to continue.`;
export const GEN_AUTH_BUTTON_TEXT = 'Connect Spotify';
export const PLAYER_AUTH_BODY_TEXT = `Failed to establish a valid Spotify Connection. ${STANDARD_TEXT}`;
export const INITIALIZATION_BODY_TEXT = `There was an issue loading the player. ${STANDARD_TEXT}`;
export const SPOTIFY_BUTTON_TEXT = 'Get Premium';
export const BUTTON_TEXT = 'Refresh';
export const SWAPPED_TITLE = 'No Player Activated';
export const SECONDARY_BUTTON_TEXT = 'Reconnect To Spotify';
export const SWAPPED_BODY_TEXT =
  'Looks like you might have swapped to another device to listen to Spotify or your ToneBirds web player was disconnected';
